import { Injectable, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ToastData {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

@Injectable({
  providedIn: 'root',
})
export class Notification {
  private _toasts = signal<ToastData[]>([]);
  public toasts = this._toasts.asReadonly();
  
  private nextId = 0;

  constructor() {}

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error');
  }
  
  info(message: string): void {
    this.show(message, 'info');
  }

  warning(message: string): void {
    this.show(message, 'warning');
  }

  private show(message: string, type: 'success' | 'error' | 'info' | 'warning') {
    const id = this.nextId++;
    this._toasts.update(t => [...t, { id, message, type }]);
    
    // Auto-remove after 4 seconds to match the progress bar draining
    setTimeout(() => {
      this.remove(id);
    }, 4000);
  }

  remove(id: number) {
    this._toasts.update(t => t.filter(toast => toast.id !== id));
  }
}
